<div class="store-reviews" *ngIf="buyerCount + otherCount > 0">
  <div class="sr-summary">
    <span class="sr-average">{{ shownAverage | number: '1.1-1' }}</span>
    <div class="sr-summary-text">
      <span class="sr-stars" [attr.aria-label]="(shownAverage | number: '1.1-1') + ' out of 5'">
        <span *ngFor="let s of stars" class="sr-star"><span class="sr-star-fill" [style.width.%]="fill(s, shownAverage) * 100">★</span>★</span>
      </span>
      <span class="sr-count" *ngFor="let line of countLines">{{ line }}</span>
      <span class="sr-platform" *ngIf="platformSummary && platformSummary.count > 0 && platformName">
        {{ platformName }}: {{ platformSummary.average | number: '1.1-1' }} from {{ platformSummary.count }} {{ platformSummary.count === 1 ? 'rating' : 'ratings' }}
      </span>
    </div>
  </div>

  <ul class="sr-list" *ngIf="reviews.length > 0">
    <li class="sr-review" *ngFor="let r of shownReviews; trackBy: trackByReview">
      <span class="sr-stars small" [attr.aria-label]="r.rating + ' out of 5'">
        <span *ngFor="let s of stars" class="sr-star"><span class="sr-star-fill" [style.width.%]="fill(s, r.rating) * 100">★</span>★</span>
      </span>
      <p class="sr-comment">{{ r.comment }}</p>
      <p class="sr-meta">{{ r.displayName }}<ng-container *ngIf="r.platform"> · {{ platformLabel(r.platform) }}</ng-container> · {{ formatDate(r.date) }}</p>
    </li>
  </ul>
  <button type="button" class="sr-more" *ngIf="reviews.length > firstShown && !expanded" (click)="expanded = true">
    Show All {{ reviews.length }} Reviews
  </button>
</div>
